import React, { useState, useEffect } from 'react';
import Button from '../../../components/button/Button';
import Header from '../../../components/header/Header';
import { ReactComponent as MingcuteTransferLine } from '../../../assets/icons/convert/mingcuteTransferLine.svg';
import { ReactComponent as LoginCross } from "../../../assets/icons/convert/marketClose.svg";
import { ReactComponent as Btc } from '../../../assets/icons/convert/btc.svg';
import { ReactComponent as Eth } from '../../../assets/icons/convert/eth.svg';
import { ReactComponent as Tether } from '../../../assets/icons/convert/tether.svg';
import axios from 'axios';
import { closeSnackbar, useSnackbar, enqueueSnackbar } from "notistack";
import './Convert.css';
import {useTranslation} from "react-i18next";

const Convert = () => {
    const {t} = useTranslation();
    const actionSnackbar = snackbarId => (
        <button className="close-button" onClick={() => closeSnackbar(snackbarId)}>
            <LoginCross />
        </button>
    );
    (function () {
        function decimalAdjust(type, value, exp) {
            if (typeof exp === 'undefined' || +exp === 0) {
                return Math[type](value);
            }
            value = +value;
            exp = +exp;
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
                return NaN;
            }
            value = value.toString().split('e');
            value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
        }

        if (!Math.floor10) {
            Math.floor10 = function (value, exp) {
                return decimalAdjust('floor', value, exp);
            };
        }
    })();
    const [currencyType, setCurrencyType] = useState('usdt');
    const [valueFrom, setValueFrom] = useState('');
    const [valueTo, setValueTo] = useState('');
    const [coinFrom, setCoinFrom] = useState('usdt');
    const [coinTo, setCoinTo] = useState('btc');
    const [rates, setRates] = useState({});
    const [balance, setBalance] = useState({});
    const [balanceFrom, setBalanceFrom] = useState(0);
    const [balanceTo, setBalanceTo] = useState(0);
    const [formValid, setFormValid] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const token = localStorage.getItem('token');

    const fetchBalance = () => {
        axios
            .get('https://api-ru.fynex.cc/api/api/users/balance', {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                // const result = .filter(item=>console.log(item))
                console.log(res.data)
                setBalance(res.data);
                setBalanceFrom(Math.floor10(res.data[coinFrom], -6));
                setBalanceTo(Math.floor10(res.data[coinTo], -6));
            });
    };

    const fetchRate = async (symbol) => {
        if (symbol === 'usdt' || symbol === 'usd') return 1;
        // const response = await axios.get(
        //     `https://api.binance.com/api/v3/ticker/24hr?symbol=${symbol.toUpperCase()}USDT`
        // );
        const response = await axios.get(
            `https://api-ru.fynex.cc/charts/api/24hr/${symbol.toUpperCase()}USDT`
        );
        return parseFloat(response.data.lastPrice);
    };

    useEffect(() => {
        const updateRates = async () => {
            const rateFrom = await fetchRate(coinFrom);
            const rateTo = await fetchRate(coinTo);
            setRates({ [coinFrom]: rateFrom, [coinTo]: rateTo });
        };
        updateRates();
        fetchBalance();
    }, [coinFrom, coinTo]);

    useEffect(() => {
        if (valueFrom && rates[coinFrom] && rates[coinTo]) {
            setValueTo((rates[coinFrom] / rates[coinTo] * valueFrom).toFixed(8));
        } else {
            setValueTo('');
        }
    }, [valueFrom, rates, coinFrom, coinTo]);

    useEffect(() => {
        fetchBalance();
    }, []);

    const handleValueChange = (e) => {
        setValueFrom(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log(Number(valueFrom) > Number(balanceFrom) || Number(valueFrom) < 0)
        if(Number(valueFrom) > Number(balanceFrom) || Number(valueFrom) < 0){
            enqueueSnackbar(t("convert.noMoney"), { action: actionSnackbar, autoHideDuration: 3000, variant: 'error', className: "snackerror" });
        }else{
            axios
                .post(
                    'https://api-ru.fynex.cc/api/api/convert',
                    {
                        valueFrom,
                        coinFrom,
                        valueTo,
                        coinTo,
                        balanceFrom: 'main',
                        balanceTo: 'main',
                        type: 'main',
                    },
                    { headers: { Authorization: `Bearer ${token}` } }
                )
                .then(() => {
                    enqueueSnackbar(t("convert.success"), { action: actionSnackbar, autoHideDuration: 3000, variant: 'success', className: "snacksuccess" });
                    fetchBalance();
                })
                .catch((error) => {
                    console.log(error);
                    
                    error.response.data.detail.forEach(errormsg => {
                        let errText = errormsg.msg == "Недостаточно средств для конвертации" ? t("convert.noMoneyConvert") : errormsg.msg
                        enqueueSnackbar(`${t("convert.err")}: ${errText}`, { action: actionSnackbar, autoHideDuration: 3000, variant: 'error', className: "snackerror" });
                    })

                })
        }


    };

    const [swapConvertEnabled, setSwapConvertEnabled] = useState(false);
    const swapConvert = async () => {
        setSwapConvertEnabled(true);
        await new Promise(resolve => setTimeout(resolve, 100)); // Small delay to ensure state updates
        setValueFrom(valueTo);
        setValueTo(valueFrom);
        setCoinFrom(coinTo);
        setCoinTo(coinFrom);
        setSwapConvertEnabled(false);
    };

    useEffect(() => {
        console.log(valueFrom);
        console.log(valueTo)

    }, [valueFrom, valueTo]);

    return (
        <div className="Convert">
            <Header hasMenu2={true} />
            <div className="ConvertWrapper">
                <div className="covertBody">

                    <h2>{t("assets.convert")}</h2>
                    <div className="inputs">
                        <div className="twoInput">
                            <div className="splitInput">
                                <div className="inputBlock">
                                    <p>{t("convert.from")}</p>
                                    <div className="select-cur">
                                        <select className="select-cur" value={coinFrom}
                                                onChange={(e) => setCoinFrom(e.target.value)}>
                                            {Object.keys(balance).map((coin) => coin !== "username_id" && coin !== "id" && (
                                                <option key={coin} value={coin}>
                                                    {coin.toUpperCase()}
                                                </option>
                                            ))}
                                        </select>
                                        <p className="balance-cur">{t("convert.balance")}: {balanceFrom} {coinFrom.toUpperCase()}</p>
                                    </div>
                                    </div>

                                <div className="inputBlock">
                                    <p>{t("convert.on")}</p>
                                    <div className="select-cur">
                                        <select value={coinTo} onChange={(e) => setCoinTo(e.target.value)}>
                                            {Object.keys(balance).map((coin) => coin !== "username_id" && coin !== "id" && (
                                                <option key={coin} value={coin}>
                                                    {coin.toUpperCase()}
                                                </option>
                                            ))}
                                        </select>
                                        <p className="balance-cur">{t("convert.balance")}: {balanceTo} {coinTo.toUpperCase()}</p>
                                    </div>
                                </div>
                            </div>
                            <button className="svg svg_btn" disabled={swapConvertEnabled} onClick={swapConvert}>
                                <MingcuteTransferLine />
                            </button>
                        </div>

                        <div className="inputCurrency">
                            <div className="currency">
                                <img src={`https://api-ru.fynex.cc/api/static/icons/${coinFrom}.png`} alt=""/>
                                <span>{coinFrom.toUpperCase()}</span>
                            </div>
                            <input
                                type="text"
                                placeholder={t("convert.inputSum")}
                                value={valueFrom}
                                onChange={handleValueChange}
                                />
                        </div>

                        <div className="inputCurrency">
                            <div className="currency">
                                <img src={`https://api-ru.fynex.cc/api/static/icons/${coinTo}.png`} alt=""/>
                                <span>{coinTo.toUpperCase()}</span>
                            </div>
                            <input type="text" value={valueTo} disabled />
                        </div>
                    </div>
                    <div className="button">
                        <Button text={t("convert.confirm")} onClick={handleSubmit} disabled={!formValid} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Convert;
